export default {
  unavailable: {
    title: 'Deze service wordt beheerd door Foodamigos',
    description:
      'Flyer- en stickerdruk is een service van het Foodamigos-team en is niet beschikbaar voor partneraccounts.',
  },
};
